module.exports = __webpack_public_path__ + "b453156a416fc83badba6431947d012a.jpg";